import { restApiClient } from '@/datasources';

export const BOOK_ACTIVE_CART_ROUTE = '/online/cart/book';

export type BookingPlatform = 'web' | 'web mobile';

export type BookedCart = {
  invoiceId: string;
  appointmentsIds: string[];
};

export async function bookActiveCart(
  platform: BookingPlatform,
  signal?: AbortSignal,
): Promise<BookedCart> {
  const { data } = await restApiClient.post<BookedCart | undefined>(
    BOOK_ACTIVE_CART_ROUTE,
    { meta: { platform } },
    { signal },
  );

  if (!data?.invoiceId) {
    throw new Error('the booking answered without an order to pay');
  }

  return data;
}
